// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3dCIB","messages":"Chat_messages__2TuR0","dateDivider":"Chat_dateDivider__2Jg9Q"};